export const parseCUI = (cui) => {
  if (!cui || typeof cui !== 'string') {
    return 'Câmp obligatoriu.'
  }

  const cleanedValue = cui.trim().toUpperCase().replace(/\s+/g, '')
  const normalizedValue = cleanedValue.startsWith('RO') ? cleanedValue.slice(2) : cleanedValue

  if (!/^\d+$/.test(normalizedValue)) {
    return 'CUI-ul trebuie să conțină doar cifre sau prefixul RO urmat de cifre.'
  }

  if (normalizedValue.length < 2 || normalizedValue.length > 10) {
    return 'CUI-ul trebuie să conțină între 2 și 10 cifre.'
  }

  return true
}
